/**
 * Mobile snap carousel + dots
 * Used by Why KrutiKala, Shop by Occasion, etc.
 */
(function () {
  if (window.__kkSnapCarousel) return;
  window.__kkSnapCarousel = true;

  const MOBILE = '(max-width: 749px)';

  function init(root) {
    const track = root.querySelector('[data-kk-snap-track]');
    const dots = Array.from(root.querySelectorAll('[data-kk-snap-dot]'));
    if (!track) return;

    const cards = Array.from(track.children);
    if (!cards.length) return;

    const mq = window.matchMedia(MOBILE);
    let ticking = false;

    function isMobile() {
      return mq.matches;
    }

    function activeIndex() {
      const left = track.scrollLeft;
      let best = 0;
      let bestDist = Infinity;
      cards.forEach((card, index) => {
        const dist = Math.abs(card.offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = index;
        }
      });
      return best;
    }

    function updateDots() {
      if (!dots.length || !isMobile()) return;
      const current = activeIndex();
      dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', index === current ? 'true' : 'false');
      });
    }

    function goTo(index) {
      const card = cards[index];
      if (!card) return;
      track.scrollTo({
        left: card.offsetLeft,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth',
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        updateDots();
        ticking = false;
      });
    }

    track.addEventListener('scroll', onScroll, { passive: true });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => goTo(index));
    });

    const onMode = () => updateDots();
    if (mq.addEventListener) mq.addEventListener('change', onMode);
    else mq.addListener(onMode);

    updateDots();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-kk-snap]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
